import { useEffect, useState } from 'react';

/**
 * Hook that automatically triggers a re-render at a specified interval
 * @param intervalSeconds - The interval in seconds (default: 10 seconds)
 */
export default function useAutoRerender(intervalSeconds: number = 10) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTick((prev) => prev + 1);
    }, intervalSeconds * 1000);

    return () => clearInterval(interval);
  }, [intervalSeconds]);

  return tick;
}
